// extracted by mini-css-extract-plugin
export default {"heading":"OpeningsHours_heading__1KOU8"};